module.exports = __webpack_public_path__ + "img/slider_galery_22.36ed15fb.jpg";